<style>
.item-block {
  width: 100%;
  text-align: center;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 10px;
}
.item-block .item-image img {
  width: 100%;
  height: 120px;
  object-fit: cover;
}
.short-item {
  display: flex;
  width: 33.3%;
}
.short-item .item-image {
  width: 140px;
  flex: 0 140px;
}
.short-item .item-body {
  widows: 100%;
  flex: 0 100%;
  text-align: left;
  padding: 0 10px;
}
.short-item .item-body ul {
  padding: 0;
  margin: 0;
}
.short-item .item-body ul li {
  font-size: 14px;
}
@media (max-width: 1280px) {
  .short-item {
    width: 100%;
    flex: 0 100%;
  }
}
</style>
<template>
  <div class="d-block">
    <div class="row">
      <div class="col-md-12">
        <p class="text-center text-success">Товар добавлен в корзину.</p>
        <div class="item-block short-item">
          <div class="item-image">
            <router-link :to="'/' + locale + '/items/' + cartItem.id">
              <img :src="cartItem.images[0]" />
            </router-link>
          </div>
          <div class="item-body">
            <div class="name">
              <router-link
                :to="'/' + locale + '/items/' + cartItem.id"
                style="display:block;"
              >
                <span v-if="cartItem.name[locale]">{{
                  cartItem.name[locale]
                }}</span>
                <span v-else>{{ cartItem.exposhoes_id }}</span>
              </router-link>
            </div>
            <div class="brand">
              <span class="badge badge-secondary">{{
                cartItem.trademark
              }}</span>
            </div>
            <div class="options">
              <ul>
                <li>
                  Размер: <span>{{ cartItem.size.name[locale] }}</span>
                </li>
                <li>
                  Кол-во пар: <span>{{ cartItem.quantity }}</span>
                </li>
              </ul>
            </div>
            <div class="price text-right">
              <span>{{ cartItem.price }} грн.</span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="flex justify-content-between"
        style="margin: 30px 0;padding: 0 15px;display:flex;width:100%;"
      >
        <router-link class="btn btn-link" :to="'/' + locale">
          Продолжить выбор
        </router-link>
        <router-link :to="'/' + locale + '/cart'" class="btn btn-primary">
          Перейти в корзину
        </router-link>
      </div>
      <div class="col-12">
        <p class="text-center text-success">Последние просмотры</p>
      </div>
      <div class="col-xl-2 col-sm-4" v-for="item in getItems" :key="item.id">
        <div class="item-block">
          <div class="item-image">
            <router-link :to="'/' + locale + '/items/' + item.id">
              <img :src="item.images[0]" />
            </router-link>
          </div>
          <div class="item-body">
            <div class="name">
              <router-link
                :to="'/' + locale + '/items/' + item.id"
                style="display:block;"
              >
                <span v-if="item.name[locale]">{{ item.name[locale] }}</span>
                <span v-else>{{ item.exposhoes_id }}</span>
              </router-link>
            </div>
            <div class="brand">
              <span class="badge badge-secondary">{{ item.trademark }}</span>
            </div>
            <div class="price text-center">
              <span>{{ item.price }} грн.</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    getItems() {
      let history = localStorage.getItem("history")
        ? JSON.parse(localStorage.getItem("history"))
        : [];
      let cart = this.$store.state.cart;
      let items = this.$store.state.GlobalData.products;
      items = items.filter(f => {
        if (history.indexOf(f.id) !== -1 && cart.find(c => c.id !== f.id)) {
          return f;
        }
      });
      return items.length > 4 ? items.slice(0, 4) : items;
    },
    cartItem() {
      let lastItem = this.$store.state.cart[this.$store.state.cart.length - 1];
      return lastItem;
    }
  },
  data() {
    return {
      locale: this.$route.params.locale
    };
  },
  watch: {
    $route(to) {
      this.locale = to.params.locale;
    }
  }
};
</script>
